import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Vertical stack with a NAMED gap, so vertical rhythm is canonical instead of each component
 * picking a `space-y-*` from memory. Map: xs=tight rows, sm=related controls, md=form fields,
 * lg=page sections. Keeps spacing between stacked elements consistent across desktop + mobile.
 */
export const STACK_GAP = { xs: 'space-y-2', sm: 'space-y-3', md: 'space-y-4', lg: 'space-y-6' } as const;

export interface StackProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Vertical gap between children — default 'md' (form-field rhythm). */
  gap?: keyof typeof STACK_GAP;
}

const Stack = React.forwardRef<HTMLDivElement, StackProps>(
  ({ gap = 'md', className, children, ...rest }, ref) => (
    <div ref={ref} className={cn(STACK_GAP[gap], className)} {...rest}>
      {children}
    </div>
  ),
);
Stack.displayName = 'Stack';

export default Stack;
